import { connect } from 'react-redux';
import {
  getUndercutConfirmList,
  stornoUndercut,
  confirmUndercut
} from '../../../store/actions/undercut';
import UndercutConfirmationTab from './UndercutConfirmationTab';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({ undercutReducer, tabsReducer, userReducer }) => ({
  undercutReducer,
  tabsReducer,
  userReducer
});

const mapDispatchToProps = {
  getUndercutConfirmList,
  stornoUndercut,
  confirmUndercut,
  modalErrorOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UndercutConfirmationTab);
